const f = {
  isURL (value, msg = 'Please introduce a valid URL') {
    const pattern = /^(http|https):\/\/[^ "]+$/i
    return pattern.test(value) ? '' : msg
  },
  isEmpty (value, msg = 'This field is required') {
    if (Array.isArray(value)) {
      return value.length === 0 ? msg : ''
    } else if (typeof value === 'object' && value !== null) {
      return Object.keys(value).length === 0 ? msg : ''
    }
    return value.trim().length === 0 ? msg : ''
  },
  minLength (value, min, msg = 'It should have at least [MIN] characters') {
    return value.length < min ? msg.replace('[MIN]', min) : ''
  },
  maxLength (value, max, msg = 'It should at most [MAX] characters') {
    return value.length > max ? msg.replace('[MAX]', max) : ''
  },
  betweenLength (value, min = 3, max = 30, msg = 'It should have between [MIN] and [MAX] characters') {
    return value.length < min || value.length > max ? msg.replace('[MIN]', min).replace('[MAX]', max) : ''
  },
  isEmail (email, msg = 'Please introduce a valid email address') {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(String(email).toLowerCase()) ? '' : msg
  }
}

export default {
  install (vue) {
    vue.validation = f
    vue.prototype.$validation = f
  }
}
